import { render, staticRenderFns } from "./StudioProduct.vue?vue&type=template&id=1ba51786&scoped=true&"
import script from "./StudioProduct.vue?vue&type=script&lang=js&"
export * from "./StudioProduct.vue?vue&type=script&lang=js&"
import style0 from "./StudioProduct.vue?vue&type=style&index=0&id=1ba51786&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba51786",
  null
  
)

export default component.exports